import React from "react";

import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  tableCellRoot: {
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 12,
    paddingBottom: 12,
    fontSize: 16,
    letterSpacing: 0.4,
    color: theme.palette.common.dark,
    fontWeight: theme.typography.bold,
    borderBottom: "0 none",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
}));

const AdminLogHeading = () => {
  const classes = useStyles();
  return (
    <TableRow>
      <TableCell className={classes.tableCellRoot}>نام پایگاه داده</TableCell>
      <TableCell className={classes.tableCellRoot}>ادمین</TableCell>
      <TableCell className={classes.tableCellRoot}>عملیات</TableCell>
      <TableCell className={classes.tableCellRoot}>تاریخ</TableCell>
      <TableCell className={classes.tableCellRoot}>نمایش</TableCell>
    </TableRow>
  );
};

export default AdminLogHeading;